// extracted by mini-css-extract-plugin
export default {"container":"hR-z","dimension":"iR-z","dimensionLabels":"jR-z"};